// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { initAppCheck } from "./appCheck";
import { conectarEmuladorFirestoreSeConfigurado } from "./emuladorFirestore";
import { conectarEmuladorAuthSeConfigurado } from "./emuladorAuth";
// import { getAnalytics } from "firebase/analytics"; // ❌ DESABILITADO para eliminar cookies

// Controle de logs via variáveis de ambiente
const DISABLE_ERROR_MASKING = import.meta.env.VITE_DISABLE_ERROR_MASKING === 'true';

// 🚀 Feature Flag: Named Databases Migration
// false = arquitetura antiga (sg-cbtkd-educa projeto separado)
// true = nova arquitetura (Named Database "cbtkdeduca")
const USE_NAMED_DATABASES = import.meta.env.VITE_USE_NAMED_DATABASES === 'true';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID,
};
const app = initializeApp(firebaseConfig);
// 🛡️ App Check (anti-scraping): inerte até VITE_APPCHECK_RECAPTCHA_KEY existir.
initAppCheck(app);

// ❌ GOOGLE ANALYTICS DESABILITADO para eliminar cookies _ga
// eslint-disable-next-line no-unused-vars
// const analytics = getAnalytics(app);

// ========================================
// INICIALIZAÇÃO DE DATABASES
// ========================================

// Database padrão (SGC) - sempre inicializado
export const db = getFirestore(app);
// Só em desenvolvimento e só com VITE_FIRESTORE_EMULATOR_HOST (ver emuladorFirestore.js).
conectarEmuladorFirestoreSeConfigurado(db);

// Firebase Functions (região padrão us-central1)
export const functions = getFunctions(app);

// Firebase Functions — região southamerica-east1 (CFs deployadas nesta região)
export const functionsSAE1 = getFunctions(app, 'southamerica-east1');

// 🔧 Conectar ao emulador em desenvolvimento
if (import.meta.env.DEV) {
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectFunctionsEmulator(functionsSAE1, 'localhost', 5001);
  } catch (err) {
    console.error('❌ [EMULATOR] ERRO ao conectar Functions ao emulador:', err);
  }
}


// Variáveis para databases e autenticação
let cbtkdeducaDatabase;
let cbtkdeventosDatabase;
let notificationsDatabase;
let cbtkddesabilitadasDatabase;
let secondaryAuthInstance;
let authInstance;

if (USE_NAMED_DATABASES) {
  // 🆕 NOVA ARQUITETURA: Named Databases no mesmo projeto
  // console.log("🚀 [MIGRATION] Using Named Databases architecture");
  
  // Database do CBTKDeduca (Named Database no mesmo projeto)
  cbtkdeducaDatabase = getFirestore(app, 'cbtkdeduca');
  
  // Database de Eventos (Named Database no mesmo projeto) - Módulo Poomsae
  cbtkdeventosDatabase = getFirestore(app, 'cbtkdeventos');
  
  // Database de Notificações (Named Database no mesmo projeto)
  // Collections: notifications, notification_tokens, notification_groups, etc.
  notificationsDatabase = getFirestore(app, 'notifications');
  
  // Database de Registros Desabilitados (Named Database no mesmo projeto)
  // Collections: praticantes desabilitados, entidades desabilitadas, etc.
  cbtkddesabilitadasDatabase = getFirestore(app, 'cbtkddesabilitadas');
  
  // Autenticação (compartilhada automaticamente!)
  authInstance = getAuth(app);
  authInstance.languageCode = "pt-BR";
  conectarEmuladorAuthSeConfigurado(authInstance);
  
  // Compatibilidade: secondaryAuth aponta para mesma auth
  secondaryAuthInstance = authInstance;
  
} else {
  // 📦 ARQUITETURA ANTIGA: Projeto separado sg-cbtkd-educa
  // console.log("⚠️  [MIGRATION] Using legacy architecture (separate project)");
  
  // Database secundário (projeto separado) - LEGADO
  const secondaryApp = initializeApp(firebaseConfig, "secondary");
  secondaryAuthInstance = getAuth(secondaryApp);
  secondaryAuthInstance.languageCode = "pt-BR";
  
  // Autenticação primária
  authInstance = getAuth(app);
  authInstance.languageCode = "pt-BR";
  
  // cbtkdeducaDb e cbtkdeventosDb dummy (Named Database ainda não existe na arquitetura antiga)
  cbtkdeducaDatabase = null;
  cbtkdeventosDatabase = null;
  notificationsDatabase = null;
  cbtkddesabilitadasDatabase = null;
}

// Exports finais
export const cbtkdeducaDb = cbtkdeducaDatabase;
export const cbtkdeventosDb = cbtkdeventosDatabase;
export const notificationsDb = notificationsDatabase;
export const cbtkddesabilitadasDb = cbtkddesabilitadasDatabase;
export const auth = authInstance;
export const secondaryAuth = secondaryAuthInstance;

// Handler global para capturar erros de permissão que são falsos alarmes
if (!DISABLE_ERROR_MASKING) {
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason && 
        event.reason.code === 'permission-denied' && 
        event.reason.message && 
        event.reason.message.includes('Missing or insufficient permissions')) {
      
      
      // Previne que o erro apareça no console como "Uncaught"
      event.preventDefault();
    }
  });
}

